"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userApi = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
var userApi = {
  findAll: function findAll(params) {
    return (0, _request.default)({
      url: '/v1/admin/user',
      params: params
    });
  },
  create: function create(data) {
    return (0, _request.default)({
      url: '/v1/admin/user',
      data: data,
      method: 'post'
    });
  },
  update: function update(id, data) {
    return (0, _request.default)({
      url: "/v1/admin/user/".concat(id),
      method: 'put',
      data: data
    });
  },
  block: function block(id) {
    return (0, _request.default)({
      url: "/v1/admin/user/".concat(id, "/block"),
      method: 'put'
    });
  },
  unblock: function unblock(id) {
    return (0, _request.default)({
      url: "/v1/admin/user/".concat(id, "/unblock"),
      method: 'put'
    });
  },
  delete: function _delete(id) {
    return (0, _request.default)({
      url: "/v1/admin/user/".concat(id),
      method: 'delete'
    });
  }
};
exports.userApi = userApi;